import accessors from '../accessors';

const canBeAligned = (element) => Boolean(accessors.getAlignConstraintForElement(element));

export default canBeAligned;
